import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView } from "@/base";
import { bondSubmissionsListView } from "@/pages/bondSubmissionsListView";

// The brokerage's own bond orders (BRK-S088) — the Surety platform's counterpart
// to SubmissionsPage, and the thing that makes a bond draft findable again.
//
// The pointer row exists from DRAFT START, so a half-filled order is listed with
// its SB number just like a filed one; the number links into the flow, which
// resumes it from the server (`/surety/submissions/:id`). Own-scoped server-side:
// PMS forces the brokerage from the session, so nothing is sent.
//
// ── THE LIST ITSELF MOVED OUT (BRK-S174) ─────────────────────────────────────
//
// This page owned the fetch, the states and the table until the Construction
// Bonds landing became the SECOND surface showing the same list. They are now
// one definition, `bondSubmissionsListView` (BRK-S253), and this page is its
// FULL-PAGE route. A copy on the landing would have been a copy of the fetch,
// the filters, the empty state and the error state — four places to fix the
// next defect.
//
// TWO FILTERS ARRIVE IN THE URL, and one of them still has no control.
// `?status=` and `?decision=` are the list's own (PMS-S461), applied
// server-side. `?accountId=` stays a LINK rather than a control (BRK-S140): the
// account profile's Submissions tab links here with it, so "this insured's bond
// orders" is a shareable, reloadable page. It is additive to the own-scoping —
// PMS still forces the brokerage from the session — which is what makes it safe
// to read an id straight out of the query string.
//
// ── A BASELISTVIEW PAGE (BRK-S253) ───────────────────────────────────────────
//
// The list, its header, filters, paging and states are `bondSubmissionsListView`.
// `?accountId=` is its link-only parameter: the list says it is narrowed, with
// the way back to all.

export function BondSubmissionsPage() {
  const { authedRequest } = useAuth();
  const def = useMemo(
    () =>
      bondSubmissionsListView({ request: authedRequest, emptyAction: true }),
    [authedRequest],
  );
  return <BaseListView def={def} />;
}
